export default __webpack_public_path__ + "static/media/grey-arrow-right.6e75bba4.svg";